<template>
<v-container fluid>
        <v-row>
            <v-col cols="12">
                <div class="stepper">
                    <ul>
                        <li :class="step1.active">
                            <span :class="step1.line"></span>
                            <span class="circle-stepper">1</span>
                            <span class="text-stepper">{{step1Title}}</span>
                        </li>
                        <li :class="step2.active">
                            <span :class="step2.line"></span>
                            <span class="circle-stepper">2</span>
                            <span class="text-stepper">{{step2Title}}</span>
                        </li>
                        <li :class="step3.active">
                            <span :class="step3.line"></span>
                            <span class="circle-stepper">3</span>
                            <span class="text-stepper">{{step3Title}}</span>
                        </li>
                    </ul>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: {
        currentStep: String | Number, default: 1,
        step1Title: String,
        step2Title: String,
        step3Title: String,
    },

    data() {
        return {
            step1: {
                active: '',
                line: '',
            },
            step2: {
                active: '',
                line: '',
            },
            step3: {
                active: '',
                line: '',
            }
        }
    },

    watch: {
        currentStep(newItem, oldItem) {
            this.setCurrentStep(newItem);
            this.controlOfHtmlSteps();
        },
    },

    methods: {
        controlOfHtmlSteps() {
            this.resetClassSteps();
            let currentStep = this.currentStep;

            switch (currentStep) {
                case 1:
                    this.step1.line = '';
                    this.step1.active = 'active';
                    break;
                case 2:
                    this.step1.active = 'active';
                    this.step1.line = 'line__bottom--step w-50 l-50';
                    this.step2.line = 'line__bottom--step w-50 r-50';
                    this.step2.active = 'active';
                    break;
                case 3:
                    this.step1.line = 'line__bottom--step w-50 l-50';
                    this.step2.line = 'line__bottom--step w-100';
                    this.step3.line = 'line__bottom--step w-50 r-50';
                    this.step3.active = 'active';
                    break;

                default:
                    break;
            }
        },

        resetClassSteps() {
            this.step1 = { active: '', line: '' };
            this.step2 = { active: '', line: '' };
            this.step3 = { active: '', line: '' };
        },

        setCurrentStep(step) {
            this.currentStep = step;
        },
    },

    mounted() {
        this.setCurrentStep(this.currentStep);
        this.controlOfHtmlSteps();
    }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
.container--fluid {
    .stepper {
        width: 100%;
        margin-top: 30px;
        display: flex;

        ul {
            display: flex;
            align-items: flex-start;
            justify-content: center;
            list-style: none;
            width: 100%;
            margin: 0;
            padding: 0;

            li {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                width: 33.33%;
                cursor: pointer;

                &.active {
                    .circle-stepper {
                        background-color: #172643;
                    }
                }

                .circle-stepper {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 24px;
                    height: 24px;
                    font-size: 16px;
                    font-weight: 500;
                    color: #ffffff;
                    background-color: #9e9d9d;
                    border-radius: 50px;
                    z-index: 2;
                }

                .text-stepper {
                    text-align: center;
                }

                .line__bottom--step {
                    position: relative;
                    border-bottom: 1px dashed #172643;
                    top: 12px;

                    &.w-50 {
                        width: 50%;
                    }
                    &.w-100 {
                        width: 100%;
                    }

                    &.l-50 {
                        margin-left: 50%;
                    }

                    &.r-50 {
                        margin-right: 50%;
                    }
                }
            }
        }
    }
}

</style>
